// Mounts app-level runtime singletons and global side effects.

import { SpeedInsights } from '@vercel/speed-insights/react';
import { Toaster } from '../components/ui/sonner';
import {
  useAnalyticsIdentity,
  useAnalyticsPageTracker,
  usePlayerSession,
  usePoppyChatLinkBlockedToast,
  useWakeLock,
} from '../hooks';

const AppChromeRuntime = () => (
  <>
    <Toaster richColors position="top-right" />
  </>
);

const AnalyticsRuntime = () => {
  useAnalyticsIdentity();
  useAnalyticsPageTracker();
  return null;
};

const InstrumentationRuntime = () => (
  <>
    <SpeedInsights />
  </>
);

export const AppRuntime = () => {
  usePlayerSession();
  usePoppyChatLinkBlockedToast();
  useWakeLock();

  return (
    <>
      <AppChromeRuntime />
      <AnalyticsRuntime />
      <InstrumentationRuntime />
    </>
  );
};
